import { FormattedDate } from 'components/misc/FormattedDate.tsx';
import MoneyDisplay from 'components/util/MoneyDisplay';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ClassifierData } from 'types/classifiers';
import { ExpenseDto } from 'types/expenses';
import { getClassifierText } from 'utils/getTranslations';

type Props = {
    expense: ExpenseDto;
    disableView?: boolean;
    classifiers: Record<string, ClassifierData>;
    readOnly: boolean;
    openExpenseModal: (expense: ExpenseDto) => void;
};

const EffortExpenseItem: React.FC<Props> = ({
    expense,
    disableView = false,
    classifiers,
    readOnly = false,
    openExpenseModal,
}) => {
    const isNewAndUnsaved = expense.currencyTypeCode === undefined && expense.expenseAmount === undefined;

    const currencyTypeCode = isNewAndUnsaved ? expense?.originalCurrencyTypeCode : expense.currencyTypeCode;
    const expenseAmount = isNewAndUnsaved ? expense?.expenseAmountOriginalCurrency : expense.expenseAmount;

    return (
        <div className="bg-paper text-fg border-divider new:border-0 new:shadow-card new:outline-hidden overflow-hidden rounded-[7px] border p-3">
            <div className="flex justify-between">
                <div className="flex">
                    <p className="text-body1 font-semibold">
                        <FormattedDate value={expense.expenseDate} fallback="" />
                    </p>
                    <p className="text-body1 text-fg-secondary ml-2">
                        {expense.employee ? `${expense.employee.name}` : ''}
                    </p>
                </div>
                <p className="text-body1">
                    {expenseAmount && !isNaN(Number(expenseAmount)) ? (
                        <MoneyDisplay amount={Number(expenseAmount)} currency={currencyTypeCode} />
                    ) : null}
                </p>
            </div>
            <div className="w-[70%]">
                {getClassifierText(classifiers['EXPENSE_TYPE'], expense.expenseTypeCode)}
                {expense.description ? `, ${expense.description}` : ''}
            </div>
            <div>
                <button
                    type="button"
                    className="text-body1 text-link cursor-pointer text-left whitespace-nowrap no-underline hover:underline"
                    onClick={() => openExpenseModal(expense)}
                >
                    <FormattedMessage id={readOnly || disableView ? 'expenses.view-expense' : 'expenses.edit'} />
                </button>
            </div>
        </div>
    );
};

export default EffortExpenseItem;
